import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { MdError } from 'react-icons/md'
import { updatePdsr, resetUpdatePdsrOutcome } from '../actions/dsr-actions'
import { redirectToNewPage } from '../../global/helpers/global-helpers'
import PageLoader from '../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'


function ProspectDsrDeleteModal({ 
    pDsrId,
    handleCloseModal, 
    updateProspectDsrOutcome, 
    updatePdsr,
    resetUpdatePdsrOutcome 
  }) {

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateProspectDsrOutcome) {
      const { updatePdsrStatus, sourceEvent } = updateProspectDsrOutcome || {};

      if (updatePdsrStatus && sourceEvent === "delete-prospect-dsr") {
        resetUpdatePdsrOutcome()
        redirectToNewPage(`/prospectors`)
      }
    }

  }, [updateProspectDsrOutcome, resetUpdatePdsrOutcome]);

  const handleClickUnpublishButton = () => {
    setShowLoader(true);
    updatePdsr({ pDsrId, status: 'deleted', sourceEvent: "delete-prospect-dsr" })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            You are about to delete this Prospector for good. Go ahead?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' onClick={() => handleClickUnpublishButton()} label='Yes, delete this' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={MdError} color='brandPink.500' boxSize="1.6em" />
        <Box color='white'>Delete Prospector</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateProspectDsrOutcome: state.updateProspectDsrOutcome.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePdsr,
      resetUpdatePdsrOutcome
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProspectDsrDeleteModal));
